import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaLink, FaClipboard, FaDownload } from 'react-icons/fa';

const UrlInputSection = ({ selectedPlatform, onSubmit, isLoading }) => {
  const [url, setUrl] = useState('');
  const [error, setError] = useState('');

  const handlePaste = async () => {
    try {
      const text = await navigator.clipboard.readText();
      setUrl(text);
    } catch (err) {
      console.error('Failed to read clipboard');
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    
    if (!url.trim()) {
      setError('Please enter a URL');
      return;
    }

    onSubmit(url, setError);
  };

  const getPlaceholder = () => {
    switch (selectedPlatform) {
      case 'youtube':
        return 'Paste YouTube video URL (e.g., youtube.com/watch?v=...)';
      case 'instagram':
        return 'Paste Instagram Reel/Post URL (e.g., instagram.com/reel/...)';
      case 'facebook':
        return 'Paste Facebook video URL (e.g., facebook.com/watch/... or facebook.com/.../videos/...)';
      case 'tiktok':
        return 'Paste TikTok video URL (e.g., tiktok.com/@username/video/...)';
      default:
        return 'Paste video URL...';
    }
  };

  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <motion.form
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        onSubmit={handleSubmit}
        className="relative"
      >
        <div className="flex items-center gap-2 bg-[#1a1a3e] border border-gray-700 rounded-2xl p-2 focus-within:border-purple-500 transition-colors">
          <div className="pl-3">
            <FaLink className="text-gray-500" size={20} />
          </div>
          
          <input
            type="text"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            placeholder={getPlaceholder()}
            className="flex-1 bg-transparent text-white px-3 py-3 outline-none placeholder-gray-500"
          />
          
          <motion.button
            type="button"
            onClick={handlePaste}
            className="px-4 py-2 bg-[#2a2a4e] text-white rounded-lg hover:bg-[#3a3a5e] transition-colors flex items-center gap-2"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <FaClipboard size={16} />
            Paste
          </motion.button>
          
          <motion.button
            type="submit"
            disabled={isLoading}
            className="px-6 py-3 bg-gradient-to-r from-purple-600 to-purple-700 text-white rounded-xl font-semibold hover:from-purple-700 hover:to-purple-800 transition-all flex items-center gap-2 disabled:opacity-50"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <FaDownload size={16} />
            {isLoading ? 'Processing...' : 'Download Video'}
          </motion.button>
        </div>

        {error && (
          <motion.p
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-red-400 mt-3 ml-2"
          >
            {error}
          </motion.p>
        )}
      </motion.form>
    </div>
  );
};

export default UrlInputSection;
